import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../login.css";
import axiosInstance, {
  initializeTokenRefresh,
} from "../../../refershTokenManage/axiosConfig";
import { LoginContext } from "../../../App";

import CommonLoader from "../../../loader/CommonLoader";
import ReCAPTCHA from "react-google-recaptcha";

const SignIn = () => {
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const [email, setEmail] = useState(""),
    [password, setPassword] = useState(""),
    [loading, setLoading] = useState(false),
    { setCreateUser, setUser, setCreateAccountManager } = useContext(LoginContext),
    navigate = useNavigate();
  const [recaptchaToken, setRecaptchaToken] = useState(null),
    [errors, setErrors] = useState({});
  let [loginError, setLoginError] = useState("");

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  const handleLogin = async (e) => {
    try {
      if (!recaptchaToken && process.env.REACT_APP_RECAPTCHA_ENABLED == true) {
        e.preventDefault();
        alert("Please complete the reCAPTCHA!");
        return;
      }
      setLoading(true);
      const response = await axiosInstance.post(`/api/login`, {
        email,
        password,
        recaptchaToken,
      }, {
        skipAuthRedirect: true
      });

      const {
        authorization,
        user: { id, name, roles, client, blesta_subscription },
      } = response.data;

      const token = authorization.token;
      const refreshToken = authorization.refresh_token;
      const permissions = roles.flatMap((role) =>
        role.permissions.map((permission) => permission.name)
      );
      if (roles[0].name === "client") {
        localStorage.setItem("client_id", client.id);
        localStorage.setItem("last_sync_time", client.last_sync_time);
      }

      localStorage.setItem("user_id", id);
      localStorage.setItem("userName", name);
      localStorage.setItem("token", token);
      localStorage.setItem("refreshToken", refreshToken);
      localStorage.setItem("userRole", roles[0].name);
      localStorage.setItem("permissions", JSON.stringify(permissions));
      initializeTokenRefresh();
      setUser({ email, isLoggedIn: true, permissions });
      setEmail("");
      setPassword("");
      setLoginError("");
      navigate("/dashboard", { state: { from: "signIn" }, replace: true });
    } catch (error) {
      console.error("Login error:", error);

      if (error.response) {
        const { status, data } = error.response;

        switch (status) {
          case 401:
            loginError = data.message;
            break;
          case 404:
            loginError = data.message;
            break;
          case 500:
            loginError = data.message;
            break;
          default:
            loginError = data.message;
            break;
        }
      } else {
        loginError = "Unable to connect to the server. Please check your network connection.";
      }

      setLoginError(loginError);
      setErrors(error.response.data.errors);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    checkLogin();
    if (token) {
      setUser({
        isLoggedIn: localStorage.getItem("token"),
        permissions: JSON.parse(localStorage.getItem("permissions")),
      });
    }
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
  }, [setUser]);

  const checkLogin = () => {
    if (
      localStorage.getItem("token") &&
      localStorage.getItem("user_id") > "0"
    ) {
      navigate("/dashboard", { state: { from: "signIn" }, replace: true });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="main signInBackground container">
      <div className="main__text-wrapper row">
        <div className="form p-3 p-md-5">
          <h3 className="sign-in-heading mb-2 mb-md-2 fs-1">Infynalytics</h3>
          <h4 className="sign-in-heading mb-2 fs-2 fw-bold heading-color text-center">Login To Your Account</h4>
          <div className="email_login">
            <div className="input_email">
              <input
                type="email"
                id="email"
                value={email}
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
                required
                className="loginFields"
              />
              <div class="error-message">
                {errors?.email && <p className="error text-danger text-center">{errors.email[0]}</p>}
              </div>
            </div>
          </div>
          <div className="password">
            <div className="input_password">
              <input
                type="password"
                id="password"
                value={password}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
                required
                className="loginFields"
              />
              <div class="error-message text-center">
                {errors?.password && <p className="error text-danger text-center">{errors.password[0]}</p>}
              </div>
            </div>
          </div>
          {loading && (
            <div className="loader-overlay">
              <CommonLoader />
            </div>
          )}
          {loginError && (
            <div className="error-message text-danger fw-bold fs-6 text-center mt-3">
              {loginError}
            </div>
          )}
          {process.env.REACT_APP_RECAPTCHA_ENABLED === 'true' && (
            <div className="recaptcha-signin">
              <ReCAPTCHA
                sitekey={RECAPTCHA_SITE_KEY}
                onChange={handleRecaptchaChange}
              />
            </div>
          )}
          <div className="text-center">
            <button className="submit" onClick={handleLogin} disabled={loading}>
              Sign In
            </button>
            <div className="newuser">
              Don't have an account?
              <span className="account ms-2" onClick={() => setCreateUser(true)}>
                Sign Up
              </span>
              <div className="forgot-password text-center">
                <div
                  onClick={() => navigate("/forgot-password")}
                  className="text-decoration-none account"
                >
                  Forgot Password?
                </div>
              </div>
            </div>
            <div className="newuser" style={{ zIndex: "9999" }}>
              <Link to="/privacy-policy" className="account ms-2">Privacy Policy</Link>{" "}{""}
              <Link to="/terms-and-conditions" className="account ms-2">Terms & Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default SignIn;
